module.exports = __webpack_public_path__ + "img/member-verify-bg-4.9f512c4f.png";